// This method changes the language, from es to en and vice versa
export const changeLanguage = (locale) => (locale === 'es' ? 'en' : 'es');

/**
 * This function gets the index where the page is according to the slug
 * @param {array} termsPages contains all terms pages
 * @param {string} locale the current language
 * @param {string} slug the current slug to the page
 * @returns Int the number the position item in the array at other case return -1
 */
export function findIndexBySlug(termsPages, locale, slug) {
  let currentLocale = locale;
  let index = termsPages.findIndex((termsPage) => termsPage[currentLocale].slug === slug);

  // If this index is -1, changes the current language
  if (index < 0) {
    currentLocale = changeLanguage(currentLocale);
    index = termsPages.findIndex((termsPage) => termsPage[currentLocale].slug === slug);
  }

  return index;
}
